import { useIsFetching } from 'react-query';
import moment from 'moment';
import {
  selectFields,
  cityDependentFields,
  insertDraftDataKeys,
} from './constants';
import {
  shutdownAlisaTemplatesQuery,
  shutdownCitiesQuery,
  shutdownInitiatorsQuery,
  shutdownNotificationsQuery,
  shutdownReasonsQuery,
  shutdownResponsibleQuery,
  shutdownTypesQuery,
  shutdownCompaniesQuery,
} from '../../../../../shared/api/queries';
import { dateFields } from '../../../common/config';

const { key: citiesKey } = shutdownCitiesQuery;
const { key: reasonsKey } = shutdownReasonsQuery;
const { key: typesKey } = shutdownTypesQuery;
const { key: initiatorsKey } = shutdownInitiatorsQuery;
const { key: responsibleKey } = shutdownResponsibleQuery;
const { key: notifyToKey } = shutdownNotificationsQuery;
const { key: templatesKey } = shutdownAlisaTemplatesQuery;
const { key: companiesKey } = shutdownCompaniesQuery;

const getMomentValue = (value) => (value ? moment(value) : value);

export const reduceCb = (acc, [key, value]) => {
  switch (true) {
    case selectFields.has(key):
      acc[insertDraftDataKeys.selectValues][key] = value;
      break;

    case cityDependentFields.has(key):
      acc[insertDraftDataKeys.cityDependentValues][key] = value;
      break;

    default:
      acc[insertDraftDataKeys.restValues][key] = dateFields.has(key)
        ? getMomentValue(value)
        : value;
  }

  return acc;
};

export const useIsValuesFetching = () => {
  const isCitiesFetching = useIsFetching(citiesKey());
  const isReasonsFetching = useIsFetching(reasonsKey);
  const isTypesFetching = useIsFetching(typesKey);
  const isInitiatorsFetching = useIsFetching(initiatorsKey().filter(Boolean));
  const isResponsibleFetching = useIsFetching(responsibleKey);
  const isNotifyToFetching = useIsFetching(notifyToKey().filter(Boolean));
  const isTemplatesFetching = useIsFetching(templatesKey);
  const isCompaniesFetching = useIsFetching(companiesKey().filter(Boolean));

  const isFetching = [
    isCitiesFetching,
    isReasonsFetching,
    isTypesFetching,
    isInitiatorsFetching,
    isResponsibleFetching,
    isNotifyToFetching,
    isTemplatesFetching,
    isCompaniesFetching,
  ].some(Boolean);

  return isFetching;
};
